import React, { createContext, useContext, useState } from "react";

const AiTripContext = createContext();

export function AiTripProvider({ children }) {
    const [aiTrip, setAiTrip] = useState(null);
    return (
        <AiTripContext.Provider value={{ aiTrip, setAiTrip }}>
            {children}
        </AiTripContext.Provider>
    );
}

export function useAiTrip() {
    return useContext(AiTripContext);
}
